/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * CartIcon
 */
export default class CartIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M9 18a2 2 0 110 4 2 2 0 010-4zm8 0a2 2 0 110 4 2 2 0 010-4zM3.383 2a3 3 0 012.89 2.193l.044.178L6.45 5h11.987a3 3 0 012.995 2.824l.005.176a3 3 0 01-.04.488l-.05.24-1 4a3 3 0 01-2.731 2.267l-.179.005H8.594l.214 1H18a1 1 0 01.117 1.993L18 18H8a1 1 0 01-.947-.678l-.03-.112L4.36 4.79a1 1 0 00-.861-.783L3.383 4H2a1 1 0 01-.117-1.993L2 2h1.383zm15.055 5H6.88l1.286 6h9.273a1 1 0 00.937-.649l.034-.108 1-4a1 1 0 00-.854-1.236L18.438 7z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

